export default {
  moneySymbol: 'NT$',
  deleteThisLine: '刪除此项',
  copyThisLine: '複製此项',
  form: {
    lightFilter: {
      more: '更多篩選',
      clear: '清除',
      confirm: '確認',
      itemUnit: '項'
    }
  },
  tableForm: {
    search: '查詢',
    reset: '重置',
    submit: '提交',
    collapsed: '展開',
    expand: '收起',
    inputPlaceholder: '請輸入',
    selectPlaceholder: '請選擇'
  },
  alert: {
    clear: '取消選擇',
    selected: '已選擇',
    item: '項'
  },
  pagination: {
    total: {
      range: '第',
      total: '條/總共',
      item: '條'
    }
  },
  tableToolBar: {
    leftPin: '固定到左邊',
    rightPin: '固定到右邊',
    noPin: '不固定',
    leftFixedTitle: '固定在左側',
    rightFixedTitle: '固定在右側',
    noFixedTitle: '不固定',
    reset: '重置',
    columnDisplay: '列展示',
    columnSetting: '列設置',
    fullScreen: '全屏',
    exitFullScreen: '退出全屏',
    reload: '刷新',
    density: '密度',
    densityDefault: '正常',
    densityLarger: '寬鬆',
    densityMiddle: '中等',
    densitySmall: '緊湊'
  },
  stepsForm: {
    next: '下一步',
    prev: '上一步',
    submit: '完成'
  },
  loginForm: {
    submitText: '登入'
  },
  editableTable: {
    onlyOneLineEditor: '只能同時編輯一行',
    action: {
      save: '保存',
      cancel: '取消',
      delete: '刪除',
      add: '新增一行資料'
    }
  },
  switch: {
    open: '打開',
    close: '關閉'
  }
};